"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestorApiError = void 0;
const shared_types_1 = require("@restor/shared-types");
/**
 * Every failure a caller sees is one of these — a 4xx body, a 5xx, a timeout or
 * a dropped connection. Callers switch on `code`, not on HTTP status or on
 * message text.
 */
class RestorApiError extends Error {
    code;
    status;
    details;
    requestId;
    constructor(params) {
        super(params.message);
        this.name = 'RestorApiError';
        this.code = params.code;
        this.status = params.status;
        this.details = params.details;
        this.requestId = params.requestId;
    }
    static fromApiError(error, status, requestId) {
        return new RestorApiError({
            code: error.code,
            message: error.message,
            status,
            details: error.details,
            requestId,
        });
    }
    /** The request never reached the server (offline, DNS, TLS). */
    static network(cause) {
        return new RestorApiError({
            code: 'NETWORK_ERROR',
            message: cause instanceof Error ? cause.message : 'Network request failed',
            status: 0,
        });
    }
    static timeout(ms) {
        return new RestorApiError({
            code: 'TIMEOUT',
            message: `Request timed out after ${ms}ms`,
            status: 0,
        });
    }
    /**
     * True when the request never completed, so the POS may safely replay it with
     * the same idempotency key (TZ §18).
     */
    get isNetworkFailure() {
        return this.status === 0;
    }
    get isUnauthorized() {
        return (this.status === 401 ||
            this.code === shared_types_1.ErrorCode.UNAUTHORIZED ||
            this.code === shared_types_1.ErrorCode.TOKEN_EXPIRED);
    }
    get isForbidden() {
        return this.status === 403;
    }
    /** Validation failures carry per-field messages for the form to render. */
    get isValidation() {
        return this.code === shared_types_1.ErrorCode.VALIDATION_ERROR;
    }
    /** Whether retrying the exact same request could plausibly succeed. */
    get isRetryable() {
        return this.isNetworkFailure || this.status === 429 || this.status >= 500;
    }
}
exports.RestorApiError = RestorApiError;
//# sourceMappingURL=errors.js.map